import { Injectable } from '@angular/core';
import { GenericAkitaHTTPService, HttpOptions } from '../../service/generic-akita-http.service';
import { HttpClient } from '@angular/common/http';
import { NetworkService } from '../../service/network.service';
import { CrowdFlowMotionChangeAlert } from '../../model/crowd-flow-alert';

@Injectable({
  providedIn: 'root'
})
export class AkitaHTTPCrowdFlowMotionChangeAlert extends GenericAkitaHTTPService<CrowdFlowMotionChangeAlert> {
  constructor(http: HttpClient, networkService: NetworkService) {
    const options: HttpOptions = {
      params: {
        type: 'CrowdFlowMotionChangeAlert',
        options: 'keyValues',
        limit: '50'
      }
    };
    super(http, networkService, '/v2/entities/', 'CrowdFlowMotionChangeAlert', options);
  }
}
